import { Card } from 'antd';
import { CSSProperties } from 'react';

interface Props {
  title: string;
  children: React.ReactNode;
  subtitle?: string;
  style?: CSSProperties;
  visible: boolean;
}

export default function SectionCard({
  title,
  subtitle,
  children,
  style,
  visible,
}: Props) {
  return (
    <Card
      type="inner"
      title={
        <>
          {title}
          {subtitle ? (
            <>
              <br />
              <span style={{ fontWeight: 400, fontSize: '0.8rem' }}>
                {subtitle}
              </span>
            </>
          ) : (
            ''
          )}
        </>
      }
      style={{ display: visible ? 'block' : 'none', ...style }}
    >
      {children}
    </Card>
  );
}
